import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function currentTimeMillis() {
  return numberToLong((new Date()).getTime());
}
//region block: exports
export {
  currentTimeMillis as currentTimeMillis8vwamy6polhm,
};
//endregion

//# sourceMappingURL=utils.mjs.map
